module.exports = __webpack_public_path__ + "images/emoji/person_frowning.c405a28dbe0d549b9e03.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/person_frowning.png
// module id = CRWn
// module chunks = 13